import { connect } from 'react-redux';

// Components
import ComparingDateInfo from './component';

const mapStateToProps = state => ({
  selectedComparingDate: state.forecastDemo.state.comparingDate,
  selectedZone: state.forecastDemo.state.zone,
  selectedTimeZone: state.forecastDemo.state.timezone,
});

export default connect(mapStateToProps)(ComparingDateInfo);



// WEBPACK FOOTER //
// ./src/components/forecast-demo/components/comparing-date-info/index.js